
const HttpUtils = {

    jsonify(object, ignore = []) {
        // return the object data as a raw object that looks good as json
        // getting rid of hidden, internal variables and functions
        const json = {};
        for (const key in object) {
            const value = object[key];
            if (typeof(value) !== 'function' && key[0] !== '_' && key[0] !== '$' && ignore.indexOf(key) === -1) {
                json[key] = value;
            }
        }
        return json;
    }

};


export {
    HttpUtils
};
